<template>
    <div v-if="!doneChunking" style="height: 100%">
            <h1 v-if="downloadProgress > 0" class="title">Downloading</h1>
            <progress v-if="downloadProgress > 0" class="progress is-large is-info" max="100" :value="downloadProgress">{{downloadProgress}}%</progress>
            <h1 v-if="downloadProgress === 100" class="title">Parsing Data</h1>
            <progress v-if="downloadProgress === 100" class="progress is-large is-info" max="100" :value="chunkingProgress">{{chunkingProgress}}%</progress>
            <div class="level" style="height: 50%">
                <b-icon
                    class="level-item"
                    pack="fas"
                    icon="sync-alt"
                    size="is-large"
                    custom-class="fa-spin">
                </b-icon>
            </div>
        </div>
</template>

<script>
    import BIcon from "buefy/src/components/icon/Icon";
    import axios from "axios";
    import Papa from "papaparse"

    export default {
        name: "CsvParser",
        components: {BIcon},
        //These are meant to be used with :prop.sync="..."
        props: {
            data: {
                type: Array,
            },
            fieldIds: {
                type: Array,
            },
            //This is the only one that does something, sets if the component is displayed at the start
            done: {
                type: Boolean,
                default: false,
            }

        },
        data: () => ({
            //Loading/done indicators
            'downloadProgress': 0,
            'chunkingProgress': 0,
            'doneChunking': false,
            'fileSizeMB': 0,
            'chunkNumber': 0,
        }),
        mounted() {
            this.doneChunking = this.done;
        },
        //For when props are bound via vi-bind:name.sync (which they all should be for this to work)
        watch: {
            doneChunking(val) {
                this.$emit('update:done', val);
            },
        },
        methods: {
            async loadCsv(url) {
                this.downloadProgress = 0;
                this.chunkingProgress = 0;
                this.doneChunking = false;
                this.fileSizeMB = 0;
                this.chunkNumber = 0;
                let me = this;
                return new Promise( async (resolve, reject) => {
                try {
                    console.log('Downloading Data');
                    //Create a new axios instance so the default Auth header is not appended
                    let client = axios.create({headers: null});
                    let response = await client.get(url, {
                        responseType: 'blob',
                        onDownloadProgress: event => {
                            me.downloadProgress = event.loaded / event.total * 100;
                        }
                    });
                    console.log('Download Complete\nNow Parsing Data');
                    me.fileSizeMB = response.data.size / (1024 * 1024);
                    let data = [];
                    let fieldIds = [];
                    Papa.parse(response.data, {
                            worker: true,
                            skipEmptyLines: true,
                            header: true,
                            chunkSize: 1024 * 1024,
                            dynamicTyping: true,
                            chunk: function (results, parser) {
                                console.log('Chunking');
                                me.chunkNumber += 1;
                                me.chunkingProgress = me.chunkNumber / me.fileSizeMB * 100;
                                if (!fieldIds.length) {
                                    fieldIds = results.meta.fields;
                                    me.$emit('update:fieldIds', fieldIds);
                                }
                                data = data.concat(results.data);
                            },
                            complete: async function (results) {
                                console.log('Parsing Complete');
                                // me.localFieldIds = results.meta.fields;
                                // data = results.data;
                                me.doneChunking = true;
                                me.$emit('update:data', data);
                                resolve([fieldIds, data]);
                            }
                        });
                } catch (error) {
                    reject(error);
                }
                });
            },
        },
    }
</script>

<style scoped>

</style>